const fillerWords = [
  "ok",
  "okay",
  "actually",
  "basically",
  "um",
  "uh",
  "just",
  "very",
  "really",
  "highly",
  "like",
  "so",
  "right",
  "yeah",
  "alright",
  "kinda",
  "well"
];

export default fillerWords;
